import { createBasicSelectors } from 'modules/utils/helpers/createBasicSelectors'

const ProductSettingsSelectors = { ...createBasicSelectors('productSettings') }

export default ProductSettingsSelectors
